var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.088 13.581C3.396 13.581.409 10.58.409 6.9.409 3.222 3.396.221 7.088.221c3.693 0 6.681 3.001 6.681 6.679 0 3.68-3.002 6.681-6.681 6.681zm0-12.544c-3.237 0-5.85 2.627-5.85 5.863 0 3.224 2.628 5.851 5.85 5.851 3.224 0 5.851-2.627 5.851-5.851 0-3.236-2.627-5.863-5.851-5.863zm.442 6.86v.788c0 .208-.164.374-.372.374s-.373-.166-.373-.374v-1.12c0-.207.165-.373.373-.373.856 0 1.548-.692 1.548-1.55 0-.858-.692-1.549-1.548-1.549-.859 0-1.549.691-1.549 1.549 0 .207-.166.373-.374.373s-.373-.166-.373-.373c0-1.272 1.038-2.295 2.296-2.295 1.272 0 2.295 1.023 2.295 2.282 0 1.148-.829 2.088-1.923 2.268zm-.372 1.77c.29 0 .525.235.525.525 0 .291-.235.526-.525.526-.291 0-.525-.235-.525-.526 0-.29.234-.525.525-.525z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.2c28b8ff9d6d7e543994c9ba99e13c07.svg";
export { ForwardRef as ReactComponent };